export default __webpack_public_path__ + "static/media/banner.2f939495.jpeg";